import moment from "moment";
import { IMessageBackEndModel, IMessageFrontEndModel } from "../types";
import { UserRole } from "../../user/enums/UserRole";

export function parseToMessagesFrontEndModel({
  messages,
  schoolPhoto,
  serviceProviderPhoto,
  studentPhoto,
  userRole,
}: {
  messages: IMessageBackEndModel[];
  schoolPhoto: string | undefined;
  serviceProviderPhoto: string | undefined;
  studentPhoto: string | undefined;
  userRole: UserRole;
}): IMessageFrontEndModel[] {
  return messages.map((message) => {
    const isMine = userRole === message.authorType;

    return {
      id: message.id,
      text: message.text,
      created_at: message.created_at,
      created_at_parsed: moment(message.created_at).format(
        "ddd, MMM D, YYYY, h:mm A",
      ),
      isMine: isMine,
      isSeen: message.isSeen,
      attachments: message.attachments,
      authorPhoto:
        message.authorType === UserRole.School
          ? schoolPhoto
          : message.authorType === UserRole.ServiceProvider
            ? serviceProviderPhoto
            : studentPhoto,
    };
  });
}
